import React, { useState } from 'react';

const NuInsToggle = ({textLeft, textRight, onChange}) => {
    const [position, setPosition] = useState(false);

    const toggle = () => {
        onChange(!position);
        setPosition(!position);
    }

    return (
        <div className="nuins_input_field">
            <div className="nuIns-toggle" onClick={toggle}>
                <div className="nuIns-toggle-text">{textLeft}</div>
                <div className="nuIns-toggle-text">{textRight}</div>
                <div className={position ? "nuIns-toggle_switch switch-right" : "nuIns-toggle_switch switch-left"}>
                    {position ? textRight : textLeft}
                </div>
            </div>
        </div>
    )
}

export default NuInsToggle;